export function downloadFile(file: File | Blob, fileName: string) {
  const a = window.document.createElement('a');

  a.href = window.URL.createObjectURL(file);
  a.download = fileName;

  a.click();
  a.remove();
}
